/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scrape_Router_Step_Browser_NoteInputs */

const en_scrape_router_step_browser_note = /** @type {(inputs: Scrape_Router_Step_Browser_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only for the hardest pages`)
};

const zh_hans1_scrape_router_step_browser_note = /** @type {(inputs: Scrape_Router_Step_Browser_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仅用于最难抓取的页面`)
};

const pt_br2_scrape_router_step_browser_note = /** @type {(inputs: Scrape_Router_Step_Browser_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só para as páginas mais difíceis`)
};

const es_scrape_router_step_browser_note = /** @type {(inputs: Scrape_Router_Step_Browser_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo para las páginas más difíciles`)
};

const fr_scrape_router_step_browser_note = /** @type {(inputs: Scrape_Router_Step_Browser_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seulement pour les pages les plus difficiles`)
};

const de_scrape_router_step_browser_note = /** @type {(inputs: Scrape_Router_Step_Browser_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur für die schwierigsten Seiten`)
};

const ru_scrape_router_step_browser_note = /** @type {(inputs: Scrape_Router_Step_Browser_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Только для самых сложных страниц`)
};

const it_scrape_router_step_browser_note = /** @type {(inputs: Scrape_Router_Step_Browser_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo per le pagine più difficili`)
};

/**
* | output |
* | --- |
* | "Only for the hardest pages" |
*
* @param {Scrape_Router_Step_Browser_NoteInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const scrape_router_step_browser_note = /** @type {((inputs?: Scrape_Router_Step_Browser_NoteInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scrape_Router_Step_Browser_NoteInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_scrape_router_step_browser_note(inputs)
	if (locale === "pt-BR") return pt_br2_scrape_router_step_browser_note(inputs)
	if (locale === "es") return es_scrape_router_step_browser_note(inputs)
	if (locale === "fr") return fr_scrape_router_step_browser_note(inputs)
	if (locale === "de") return de_scrape_router_step_browser_note(inputs)
	if (locale === "ru") return ru_scrape_router_step_browser_note(inputs)
	if (locale === "it") return it_scrape_router_step_browser_note(inputs)
	return en_scrape_router_step_browser_note(inputs)
});